import { useState, useRef, useEffect } from "react";
import { RelatoriosCreateStatus } from "../../../util/enum";
import axios from 'axios';
import RelatorioApiService from "../../../services/api/RelatorioApiService";

const useProcessingStatus = () => {
    const [processing, setProcessing] = useState("");
    const [processingMessage, setProcessingMessage] = useState(null);

    const intervalRef = useRef(null);
    const controllerRef = useRef(new AbortController());

    const getProcessingStatus = async () => {
        try {
            const resp = await RelatorioApiService.getStatusCreateRelatoriosTurnoverHistoricoCapacidade({ signal: controllerRef.current.signal });

            const rawStatus = resp.data.status;
            setProcessing(rawStatus);

            if (rawStatus === RelatoriosCreateStatus.IN_PROGRESS) {
                setProcessingMessage("Criando...");
            } else if (rawStatus === RelatoriosCreateStatus.COMPLETED) {
                setProcessingMessage("Feito");
                clearInterval(intervalRef.current);
            } else if (rawStatus === RelatoriosCreateStatus.FAILED) {
                setProcessingMessage("Erro");
                clearInterval(intervalRef.current);
            }  else {
                setProcessingMessage(null);
                clearInterval(intervalRef.current);
            }

        } catch (err) {
            if (axios.isCancel(err)) {
                console.log('Requisição de status cancelada');
                return;
            }
            console.error('Erro ao consultar status de criação de relatórios.', err);
            setProcessing(RelatoriosCreateStatus.FAILED);
            setProcessingMessage("Erro status");
            clearInterval(intervalRef.current);
        }
    };

    useEffect(() => {
        getProcessingStatus();
        intervalRef.current = setInterval(getProcessingStatus, 30000);

        return () => {
            clearInterval(intervalRef.current);
            controllerRef.current.abort();
        };
    }, []);

    const startStatusCheck = () => {
        getProcessingStatus();
        clearInterval(intervalRef.current);
        intervalRef.current = setInterval(getProcessingStatus, 30000);
    };

    return { processing, processingMessage, startStatusCheck };
}

export default useProcessingStatus;